import { baseCustomQuery } from '../baseQuery/baseCustomQuery';

const BASE_URL = process.env.https://fd.dev-pharmanavigator.senderrarx.com/backend-portal/;

const basePharmaNavigatorQuery = baseCustomQuery(BASE_URL)

export default basePharmaNavigatorQuery;
